import { Zap } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import type { CalendarSlot } from '../../stores/calendarStore';

interface AlwaysRunningStripProps {
  slots: CalendarSlot[];
}

export function AlwaysRunningStrip({ slots }: AlwaysRunningStripProps) {
  const budgetCheckSlots = slots
    .filter((s) => s.job_id === 'budget-check')
    .sort((a, b) => b.scheduled_at.localeCompare(a.scheduled_at));

  const lastRun = budgetCheckSlots.find((s) => s.status === 'completed');

  return (
    <div className="bg-accent-purple/10 border border-accent-purple/20 rounded-lg p-3 mb-4 flex items-center gap-3">
      <Zap className="h-4 w-4 text-accent-purple flex-shrink-0" />
      <span className="text-sm font-medium text-accent-purple">Always Running</span>

      <span className="px-2 py-0.5 rounded-full bg-accent-purple/20 text-xs font-medium text-accent-purple">
        budget-check
      </span>

      <span className="text-xs text-text-secondary">Every 60 min</span>

      {lastRun ? (
        <span className="text-xs text-text-muted ml-auto">
          Last run: {format(parseISO(lastRun.scheduled_at), 'h:mm a')}
        </span>
      ) : null}
    </div>
  );
}

export default AlwaysRunningStrip;
